module.exports = __webpack_public_path__ + "assets/img/pyramid_people-2_01.3480cc16.png";